<template>
    <q-layout view="hHh Lpr lff">
        <q-header bordered elevated class="bg-gradient">
            <q-toolbar class="container-menu"
                       style="min-height: 55px">
                <q-btn flat dense stretch
                       class="q-px-sm lt-md"
                       icon="mdi-menu"
                       aria-label="Menu"
                       @click="leftDrawerOpen = !leftDrawerOpen" />
                <q-toolbar-title>
                    <router-link to="/"><img :src="require('@/assets/img/logos/avenir-white.png')" height="30" class="q-mt-xs gt-xs" /></router-link>
                </q-toolbar-title>

                <q-btn stretch flat no-caps
                       class="gt-sm text-white text-weight-regular"
                       :label="staticMenuItems.home.name"
                       :to="staticMenuItems.home.path"></q-btn>

                <q-btn-dropdown-menu :mainClickPath="staticMenuItems.products.mainClickPath.toString()" hover :menuItems="staticMenuItems.products" />

                <q-btn stretch flat no-caps
                       class="gt-sm text-white text-weight-regular"
                       :label="staticMenuItems.store.name"
                       :to="staticMenuItems.store.path"></q-btn>

                <q-btn-dropdown-menu :mainClickPath="staticMenuItems.activation.mainClickPath.toString()" hover :menuItems="staticMenuItems.activation" />
                <q-btn-dropdown-menu :mainClickPath="staticMenuItems.support.mainClickPath.toString()" hover :menuItems="staticMenuItems.support" />
                <q-btn-dropdown-menu :mainClickPath="staticMenuItems.downloads.mainClickPath.toString()" hover :menuItems="staticMenuItems.downloads" />

                <cart-menu />

                <q-separator dark vertical v-if="isLoggedIn" />
                <q-separator v-else class="q-mx-xs" />

                <account-menu :showLogin.sync="showLogin" @close="showLogin = false" />
            </q-toolbar>
            <q-bar v-if="showUpdatedTermsNotice" class="bg-secondary">
                <div class="container-menu">
                    <div class="updated-terms-info" :class="$q.screen.width > 1023 ? 'q-px-md' : ''">
                        <q-badge v-if="$q.screen.width > 270" rounded color="yellow-8" class="q-mr-sm" />
                        <div style="min-width: 215px; font-size: 0.8rem;">
                            Our <router-link class="text-white" style="text-decoration: underline;" to="/terms">Terms of Use</router-link> Have Been Updated
                        </div>
                        <div v-if="$q.screen.width > 410" class="q-ml-md" style="font-size: 0.65rem;">
                            {{ termsLastUpdated }}
                        </div>
                    </div>
                </div>
            </q-bar>
        </q-header>

        <q-drawer v-model="leftDrawerOpen"
                  bordered
                  overlay>
            <navigation-menu @login="showLogin = true" />
        </q-drawer>
        <q-page-container>
            <q-page class="page">
                <router-view />
            </q-page>
        </q-page-container>

        <consent-banner />

        <app-footer />
    </q-layout>
</template>
<script>
    import accountMenu from '@/components/menus/AccountMenu'
    import cartMenu from '@/components/menus/CartMenu'
    import qBtnDropdownMenu from '@/components/menus/QBtnDropdownMenu'
    import consentBanner from '@/components/ConsentBanner';

    import navigationMenu from '@/components/menus/NavigationMenu'
    import appFooter from '@/layouts/AppFooter'
    import { staticMenuItems } from '@/plugins/menuItems'
    import { TERMS_LAST_UPDATED } from '@/plugins/menuItems'
    import { format, parseISO, differenceInDays } from 'date-fns'

    export default {
        name: 'MainLayout',
        components: {
            accountMenu,
            cartMenu,
            qBtnDropdownMenu,
            navigationMenu,
            appFooter,
            consentBanner,
        },
        data() {

            const lastUpdatedDate = parseISO(TERMS_LAST_UPDATED);
            const today = new Date();
            const daysSinceUpdate = differenceInDays(today, lastUpdatedDate);

            return {
                showLogin: false,
                isPrototype: false,
                leftDrawerOpen: false,
                staticMenuItems: staticMenuItems,
                termsLastUpdated: format(parseISO(TERMS_LAST_UPDATED), 'MMMM d, yyyy'),
                //The Terms of Use Notification will show the date they are changed and for 60 days after.
                showUpdatedTermsNotice: daysSinceUpdate <= 60,
            }
        },
        computed: {
            isLoggedIn() { return this.$store.getters.isLoggedIn },
        },
        created() {
            var path = window.location.toString()
            var substring = 'avenir-online.com'
            if (path.includes(substring)) {
                this.isPrototype = false
            }
            else {
                this.isPrototype = true
            }

        },
    }
</script>
<style lang="scss" scoped>

    .q-header .q-btn:focus, .q-header .q-btn:hover {
        border-left: inset 1px rgba(22, 70, 111, 0.25);
        border-right: inset 1px rgba(22, 70, 111, 0.25);
        margin-left: -1px;
        margin-right: -1px;
        margin-top: 1px;
        margin-bottom: 1px;
    }

    .updated-terms-info {
        display: flex;
        align-items: center;
    }

    </style>
